export const translations = {
  en: {
    common: {
      save: "Save",
      cancel: "Cancel",
      search: "Search",
      reset: "Reset",
      loading: "Loading...",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      continue: "Continue",
      back: "Back",
      submit: "Submit",
      success: "Success",
      error: "Error",
      today: "Today",
      date: "Date",
      shift: "Shift",
      dayShift: "Day Shift",
      nightShift: "Night Shift",
      all: "All",
      total: "Total",
      amount: "Amount",
      liters: "Liters",
      pcs: "Pcs",
      petrol: "Petrol",
      diesel: "Diesel",
      oil: "Oil",
      cash: "Cash",
      online: "Online",
      credit: "Credit",
      week: "Week",
      month: "Month",
      year: "Year",
      day: "Day",
    },
    sidebar: {
      logo: "KAVIRAJ AGENCIES",
      dashboard: "Dashboard",
      dailyEntry: "Daily Entry",
      pricing: "Pricing",
      reports: "Reports",
      settings: "Settings",
      logout: "Logout",
      todaysThought: "Today's Thought:",
    },
    dashboard: {
      title: "Dashboard",
      totalSales: "TOTAL SALES",
      petrolSales: "PETROL SALES",
      dieselSales: "DIESEL SALES",
      oilSales: "OIL SALES",
      paymentSummary: "PAYMENT SUMMARY",
      totalCollections: "Total Collections",
      salesBreakdown: "SALES BREAKDOWN",
      quickOverview: "QUICK OVERVIEW",
      entries: "Entries",
      pendingCredit: "Pending Credit",
      vsYesterday: "vs Yesterday",
      noSalesData: "No sales data available yet.",
      fetchError: "Failed to fetch dashboard data",
    },
    dailyEntry: {
      title: "Daily Entry",
      readOnly: "READ ONLY",
      auditCreated: "Created:",
      auditLastUpdate: "Last Update:",
      machine1: "Machine 1",
      machine2: "Machine 2",
      opening: "Opening (L)",
      closing: "Closing (L)",
      openingP: "Opening (P)",
      closingP: "Closing (P)",
      testFuel: "Test Fuel (L)",
      petrolSold: "Petrol Sold (L)",
      petrolAmount: "Petrol Amount (₹)",
      dieselSold: "Diesel Sold (L)",
      dieselAmount: "Diesel Amount (₹)",
      oilPocketSystem: "OIL (POCKET SYSTEM)",
      type: "Type",
      soldPcs: "Sold (Pcs)",
      oilTotalAmount: "Oil Total Amount (₹)",
      payment: "PAYMENT",
      cashAmount: "Cash Amount (₹)",
      onlineAmount: "Online Amount (UPI/Paytm) (₹)",
      creditAmount: "Credit Amount (₹)",
      totalEntered: "Total Entered (₹)",
      summary: "SUMMARY",
      grandTotal: "GRAND TOTAL (₹)",
      totalMatched: "Total Matched. Entry is Valid.",
      mismatch: "Mismatch: Difference of",
      saveEntry: "SAVE ENTRY",
      saving: "SAVING...",
      recentEntries: "Recent Entries",
      clickToLoad: "* Click to load into form",
      savedBy: "Saved By",
      confirmAction: "Confirm Action",
      saveConfirmText: "Data already exists for this date and shift. Are you sure you want to update it? This will overwrite the previous entry.",
      loadConfirmText: "Are you sure you want to load this entry? Any unsaved changes in the current form will be lost.",
      changeConfirmText: "Are you sure you want to change the {type}? Any unsaved changes in the current form will be lost.",
    },
    pricing: {
      title: "Pricing",
      fuelPricing: "FUEL PRICING",
      petrolPrice: "Petrol Price (₹ / Ltr)",
      dieselPrice: "Diesel Price (₹ / Ltr)",
      oilPricing: "OIL PRICING (POCKET SYSTEM)",
      ml20Price: "20 ml Price (₹)",
      ml40Price: "40 ml Price (₹)",
      ml60Price: "60 ml Price (₹)",
      pricingNote: "These prices will be used for all calculations in Daily Entry.",
      savePricing: "SAVE PRICING",
      pricingSaved: "Pricing saved successfully!",
    },
    reports: {
      title: "Reports",
      fromDate: "From Date",
      toDate: "To Date",
      exportExcel: "Export Excel",
      totalRecords: "Total Records",
      reportHeader: "KAVIRAJ AGENCIES - SALES REPORT",
      reportPeriod: "Report Period",
      shiftFilter: "Shift Filter",
      fetchError: "Failed to fetch reports",
      generatingReport: "Generating Report...",
      noRecordsFound: "No records found for the selected period.",
    },
    settings: {
      title: "System Settings",
      manageUsers: "Manage users and activity",
      userManagement: "User Management",
      auditLogs: "Audit Logs",
      generalSettings: "General Settings",
      addNewUser: "Add New User",
      name: "Name",
      email: "Email",
      role: "Role",
      status: "Status",
      active: "Active",
      time: "Time",
      module: "Module",
      user: "User",
      description: "Description",
      language: "Language",
      selectLanguage: "Select Language",
      english: "English",
      tamil: "Tamil",
      editUserDetails: "Edit User Details",
      createNewAccount: "Create New Account",
      fullName: "Full Name",
      emailAddress: "Email Address",
      password: "Password",
      leaveBlank: "(Leave blank to keep current)",
      userRole: "User Role",
      staff: "Staff (Regular Access)",
      admin: "Admin (Full Access)",
      saveChanges: "Save Changes",
      createAccount: "Create Account",
      auditDetails: "Audit Log Details",
      performedBy: "Performed By",
      rawData: "Raw Data",
      closeDetails: "Close Details",
      actions: "Actions",
      failedToFetchUsers: "Failed to fetch users",
      couldNotReachServer: "Could not reach server",
      failedToFetchLogs: "Failed to fetch audit logs",
      actionFailed: "Action failed",
      noUsersFound: "No users found",
    },
    thoughts: [
      "Believe you can and you're halfway there.",
      "Your only limit is your mind.",
      "Every day is a second chance.",
      "Keep going, you're doing great!",
      "Make today amazing.",
      "Success is not final, failure is not fatal.",
      "Dream big and dare to fail.",
      "Don't stop until you're proud.",
      "Small steps lead to big results.",
      "Work hard in silence, let success be your noise.",
      "Be the change you wish to see in the world.",
      "Your time is limited, don't waste it.",
      "It always seems impossible until it's done.",
      "Happiness is not something ready made.",
      "Be so good they can't ignore you.",
      "Action is the foundational key to all success.",
      "The secret of getting ahead is getting started.",
      "Don't count the days, make the days count.",
      "Positive mind, positive vibes, positive life.",
      "Everything you want is on the other side of fear.",
      "Success starts with self-discipline.",
      "Hard work beats talent every time.",
      "Be a voice, not an echo.",
      "The best way to predict the future is to create it.",
      "Stay hungry, stay foolish.",
      "Focus on being productive instead of busy.",
      "Believe in yourself and all that you are.",
      "Your energy is your greatest asset.",
      "Integrity is doing the right thing.",
      "Great things never come from comfort zones.",
      "Excellence is not a gift, but a skill."
    ]
  },
  ta: {
    common: {
      save: "சேமி",
      cancel: "ரத்து செய்",
      search: "தேடு",
      reset: "மீட்டமை",
      loading: "ஏற்றப்படுகிறது...",
      actions: "செயல்கள்",
      edit: "திருத்து",
      delete: "நீக்கு",
      confirm: "உறுதிப்படுத்து",
      yes: "ஆம்",
      no: "இல்லை",
      continue: "தொடரவும்",
      back: "பின்செல்",
      submit: "சமர்ப்பி",
      success: "வெற்றி",
      error: "பிழை",
      today: "இன்று",
      date: "தேதி",
      shift: "ஷிப்ட்",
      dayShift: "பகல் ஷிப்ட்",
      nightShift: "இரவு ஷிப்ட்",
      all: "அனைத்தும்",
      total: "மொத்தம்",
      amount: "தொகை",
      liters: "லிட்டர்",
      pcs: "எண்ணிக்கை",
      petrol: "பெட்ரோல்",
      diesel: "டீசல்",
      oil: "ஆயில்",
      cash: "ரொக்கம்",
      online: "ஆன்லைன்",
      credit: "கடன்பற்று",
      week: "வாரம்",
      month: "மாதம்",
      year: "வருடம்",
      day: "நாள்",
    },
    sidebar: {
      logo: "கவிராஜ் ஏஜென்சிஸ்",
      dashboard: "டாஷ்போர்டு",
      dailyEntry: "தினசரி பதிவு",
      pricing: "விலை நிர்ணயம்",
      reports: "அறிக்கைகள்",
      settings: "அமைப்புகள்",
      logout: "வெளியேறு",
      todaysThought: "இன்றைய சிந்தனை:",
    },
    dashboard: {
      title: "டாஷ்போர்டு",
      totalSales: "மொத்த விற்பனை",
      petrolSales: "பெட்ரோல் விற்பனை",
      dieselSales: "டீசல் விற்பனை",
      oilSales: "ஆயில் விற்பனை",
      paymentSummary: "பணம் செலுத்திய விவரம்",
      totalCollections: "மொத்த வசூல்",
      salesBreakdown: "விற்பனை விவரம்",
      quickOverview: "சுருக்கமான பார்வை",
      entries: "பதிவுகள்",
      pendingCredit: "நிலுவையில் உள்ள கடன்",
      vsYesterday: "நேற்றைய விற்பனையுடன்",
      noSalesData: "விற்பனை தரவு எதுவும் இன்னும் இல்லை.",
      fetchError: "டாஷ்போர்டு தரவை எடுப்பதில் தோல்வி",
    },
    dailyEntry: {
      title: "தினசரி பதிவு",
      readOnly: "பார்க்க மட்டும்",
      auditCreated: "உருவாக்கப்பட்டது:",
      auditLastUpdate: "கடைசி மாற்றம்:",
      machine1: "மெஷின் 1",
      machine2: "மெஷின் 2",
      opening: "ஆரம்ப அளவு (L)",
      closing: "முடிவு அளவு (L)",
      openingP: "ஆரம்ப அளவு (P)",
      closingP: "முடிவு அளவு (P)",
      testFuel: "டெஸ்ட் எரிபொருள் (L)",
      petrolSold: "விற்கப்பட்ட பெட்ரோல் (L)",
      petrolAmount: "பெட்ரோல் தொகை (₹)",
      dieselSold: "விற்கப்பட்ட டீசல் (L)",
      dieselAmount: "டீசல் தொகை (₹)",
      oilPocketSystem: "ஆயில் (பாக்கெட் முறை)",
      type: "வகை",
      soldPcs: "விற்கப்பட்டவை (எண்ணிக்கை)",
      oilTotalAmount: "ஆயில் மொத்த தொகை (₹)",
      payment: "பணம் செலுத்துதல்",
      cashAmount: "ரொக்கத் தொகை (₹)",
      onlineAmount: "ஆன்லைன் தொகை (UPI/Paytm) (₹)",
      creditAmount: "கடன் தொகை (₹)",
      totalEntered: "உள்ளிடப்பட்ட மொத்தம் (₹)",
      summary: "சுருக்கம்",
      grandTotal: "மொத்த தொகை (₹)",
      totalMatched: "மொத்தம் பொருந்தியது. பதிவு சரியானது.",
      mismatch: "முரண்பாடு: வித்தியாசம்",
      saveEntry: "பதிவை சேமி",
      saving: "சேமிக்கப்படுகிறது...",
      recentEntries: "சமீபத்திய பதிவுகள்",
      clickToLoad: "* படிவத்தில் ஏற்ற கிளிக் செய்யவும்",
      savedBy: "சேமித்தவர்",
      confirmAction: "செயலை உறுதிப்படுத்தவும்",
      saveConfirmText: "இந்த தேதி மற்றும் ஷிப்ட்டிற்கு தரவு ஏற்கனவே உள்ளது. அதை மாற்ற விரும்புகிறீர்களா? இது முந்தைய பதிவை அழித்துவிடும்.",
      loadConfirmText: "இந்தப் பதிவை ஏற்ற விரும்புகிறீர்களா? தற்போதைய படிவத்தில் சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
      changeConfirmText: "{type} மாற்ற விரும்புகிறீர்களா? தற்போதைய படிவத்தில் சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
    },
    pricing: {
      title: "விலை நிர்ணயம்",
      fuelPricing: "எரிபொருள் விலை",
      petrolPrice: "பெட்ரோல் விலை (₹ / லிட்டர்)",
      dieselPrice: "டீசல் விலை (₹ / லிட்டர்)",
      oilPricing: "ஆயில் விலை (பாக்கெட் முறை)",
      ml20Price: "20 மி.லி விலை (₹)",
      ml40Price: "40 மி.லி விலை (₹)",
      ml60Price: "60 மி.லி விலை (₹)",
      pricingNote: "இந்த விலைகள் தினசரி பதிவில் அனைத்து கணக்கீடுகளுக்கும் பயன்படுத்தப்படும்.",
      savePricing: "விலையை சேமி",
      pricingSaved: "விலை வெற்றிகரமாக சேமிக்கப்பட்டது!",
    },
    reports: {
      title: "அறிக்கைகள்",
      fromDate: "ஆரம்ப தேதி",
      toDate: "முடிவு தேதி",
      exportExcel: "எக்செல் ஏற்றுமதி",
      totalRecords: "மொத்த பதிவுகள்",
      reportHeader: "கவிராஜ் ஏஜென்சிஸ் - விற்பனை அறிக்கை",
      reportPeriod: "அறிக்கை காலம்",
      shiftFilter: "ஷிப்ட் வடிகட்டி",
      fetchError: "அறிக்கைகளைப் பெறுவதில் தோல்வி",
      generatingReport: "அறிக்கை உருவாக்கப்படுகிறது...",
      noRecordsFound: "தேர்ந்தெடுக்கப்பட்ட காலத்திற்கு பதிவுகள் எதுவும் இல்லை.",
    },
    settings: {
      title: "கணினி அமைப்புகள்",
      manageUsers: "பயனர்கள் மற்றும் செயல்பாடுகளை நிர்வகிக்கவும்",
      userManagement: "பயனர் மேலாண்மை",
      auditLogs: "தணிக்கை பதிவுகள்",
      generalSettings: "பொதுவான அமைப்புகள்",
      addNewUser: "புதிய பயனரைச் சேர்",
      name: "பெயர்",
      email: "மின்னஞ்சல்",
      role: "பதவி",
      status: "நிலை",
      active: "செயலில்",
      time: "நேரம்",
      module: "பகுதி",
      user: "பயனர்",
      description: "விவரம்",
      language: "மொழி",
      selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
      english: "ஆங்கிலம்",
      tamil: "தமிழ்",
      editUserDetails: "பயனர் விவரங்களைத் திருத்து",
      createNewAccount: "புதிய கணக்கை உருவாக்கு",
      fullName: "முழு பெயர்",
      emailAddress: "மின்னஞ்சல் முகவரி",
      password: "கடவுச்சொல்",
      leaveBlank: "(தற்போதையதை வைத்திருக்க காலியாக விடவும்)",
      userRole: "பயனர் பதவி",
      staff: "ஊழியர் (சாதாரண அணுகல்)",
      admin: "நிர்வாகி (முழு அணுகல்)",
      saveChanges: "மாற்றங்களைச் சேமி",
      createAccount: "கணக்கை உருவாக்கு",
      auditDetails: "தணிக்கை பதிவு விவரங்கள்",
      performedBy: "செய்தவர்",
      rawData: "மூல தரவு",
      closeDetails: "விவரங்களை மூடு",
      actions: "செயல்கள்",
      failedToFetchUsers: "பயனர்களைப் பெறுவதில் தோல்வி",
      couldNotReachServer: "சேவையகத்தைத் தொடர்பு கொள்ள முடியவில்லை",
      failedToFetchLogs: "தணிக்கைப் பதிவுகளைப் பெறுவதில் தோல்வி",
      actionFailed: "செயல் தோல்வியடைந்தது",
      noUsersFound: "பயனர்கள் யாரும் இல்லை",
    },
    thoughts: [
      "உன்னால் முடியும் என்று நம்பு, நீ பாதியை கடந்துவிட்டாய்.",
      "உன் மனமே உனது ஒரே எல்லை.",
      "ஒவ்வொரு நாளும் ஒரு இரண்டாம் வாய்ப்பு.",
      "தொடர்ந்து செல், நீ சிறப்பாக செய்கிறாய்!",
      "இன்றைய நாளை அற்புதமானதாக மாற்று.",
      "வெற்றி இறுதியானது அல்ல, தோல்வி ஆபத்தானது அல்ல.",
      "பெரிய கனவு காணுங்கள் மற்றும் தோல்வியடைய துணியுங்கள்.",
      "நீ பெருமைப்படும் வரை நிறுத்தாதே.",
      "சிறிய படிகள் பெரிய முடிவுகளுக்கு வழிவகுக்கும்.",
      "அமைதியாக கடினமாக உழைக்கவும், வெற்றி உங்களின் சத்தமாக இருக்கட்டும்.",
      "உலகில் நீங்கள் காண விரும்பும் மாற்றமாக இருங்கள்.",
      "உங்கள் நேரம் குறைவானது, அதை வீணாக்காதீர்கள்.",
      "அது முடிக்கும் வரை எப்போதும் சாத்தியமற்றதாகவே தோன்றும்.",
      "மகிழ்ச்சி என்பது தயாராக இருக்கும் ஒன்றல்ல.",
      "அவர்கள் உங்களைப் புறக்கணிக்க முடியாத அளவுக்குச் சிறப்பாக இருங்கள்.",
      "செயலே அனைத்து வெற்றிக்கும் அடிப்படை திறவுகோல்.",
      "முன்னேறுவதன் ரகசியம் தொடங்குவதே.",
      "நாட்களை எண்ணாதே, நாட்களை பயனுள்ளதாக்கு.",
      "நேர்மறை எண்ணம், நேர்மறை அதிர்வுகள், நேர்மறை வாழ்க்கை.",
      "உங்களுக்குத் தேவையான அனைத்தும் பயத்தின் மறுபக்கத்தில் உள்ளன.",
      "வெற்றி சுய ஒழுக்கத்துடன் தொடங்குகிறது.",
      "கடின உழைப்பு ஒவ்வொரு முறையும் திறமையை வெல்லும்.",
      "ஒரு குரலாக இருங்கள், எதிரொலியாக அல்ல.",
      "எதிர்காலத்தை கணிக்க சிறந்த வழி அதை உருவாக்குவதே.",
      "பசியுடன் இருங்கள், ஆர்வத்துடன் இருங்கள்.",
      "பரபரப்பாக இருப்பதை விட பயனுள்ளதாக இருப்பதில் கவனம் செலுத்துங்கள்.",
      "உன்னையும் உன்னிடம் உள்ள அனைத்தையும் நம்பு.",
      "உங்கள் ஆற்றலே உங்கள் மிகப்பெரிய சொத்து.",
      "நேர்மை என்பது சரியானதைச் செய்வது.",
      "சிறந்த விஷயங்கள் ஒருபோதும் சௌகரியமான இடங்களிலிருந்து வருவதில்லை.",
      "சிறப்பு என்பது ஒரு பரிசு அல்ல, ஒரு திறன்."
    ]
  }
};
